module.exports = __webpack_public_path__ + "static/media/document-hand-held-writing-active.56b62e2b.svg";